import type { Ref } from 'vue';
import type { HekateDisplayForm } from '@onshape/www-inertia';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class ContactSalesProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public override onSuccess({
    formDefinition,
    redirectUrl,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
    redirectUrl: string | null;
  }): void {
    super.onSuccess({ formDefinition, redirectUrl });
  }
}
